export default __webpack_public_path__ + "static/media/residue_practice_burn.7176d0fe.jpg";